export default "__VITE_ASSET__CO28in02__"